var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"typeContainer"},[_c('span',{staticClass:"itemName"},[_vm._v(_vm._s(_vm.title))]),_c('span',{staticClass:"percentValue"},[_vm._v(_vm._s(_vm.percentValue)+"%")])])}
var staticRenderFns = []

export { render, staticRenderFns }